import { render, staticRenderFns } from "./NationalitiesSelect.vue?vue&type=template&id=54e2548b"
import script from "./NationalitiesSelect.vue?vue&type=script&lang=js"
export * from "./NationalitiesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports